<template>
    <rkm-navbar
        :open="open"
        class="rkm-navbar"
    >
        <rkm-navbar-nav-icon @click="$emit('toggle')" />

        <rkm-navbar-brand class="ml-3">
            <span>Intranet</span>
        </rkm-navbar-brand>

        <rkm-navbar-nav class="ml-auto rkm-navbar-nav">
            <rkm-nav-item-dropdown right>
                <template slot="button-content">
                    <rkm-icon :icon="['far', 'user-circle']" /> {{ usuario ? usuario.nome : null }}
                </template>

                <rkm-dropdown-item :to="{name: 'perfil-edit'}">
                    <rkm-icon :icon="['far', 'user-circle']" /> Meu perfil
                </rkm-dropdown-item>

                <rkm-dropdown-divider />

                <rkm-dropdown-item
                    @click="handleLogout"
                    color="danger"
                >
                    <rkm-icon icon="door-open" /> Sair do sistema
                </rkm-dropdown-item>
            </rkm-nav-item-dropdown>
        </rkm-navbar-nav>
    </rkm-navbar>
</template>

<script>
// Mixins.
import {error, notification} from '@/mixins'

// Vuex
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getExpiration']),
        ...mapGetters({usuario: 'getUsuario'}),
    },
    data: () => ({
        logout: null,
        notification: null,
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions([
            'clearLocalStorage',
            'setExpiration',
            'setLoading',
            'setToken',
            'unsetLoading',
        ]),
        handleExpirationToken() {
            if (this.getExpiration > 0) {
                const date = new Date()
                const expiration = new Date(this.getExpiration * 1000)
                const diff = ((expiration.getTime() - date.getTime()))

                if ((diff - (300 * 1000)) > 0) {
                    this.notification = setTimeout(() => {
                        this.showWarningConfirmation(
                            'Expiração da sessão',
                            `A sessão vai expirar em 5 minutos, deseja atualuzar a sessão?`,
                            this.handleRefreshToken,
                        )
                    }, diff - (300 * 1000))
                }

                this.logout = setTimeout(() => {
                    this.clearLocalStorage().then(this.$router.push({name: 'login'}))
                }, diff)
            }
        },
        handleLogout() {
            this.repositories.autenticacao.logout()
                .catch(this.handleError)
                .finally(() => {
                    this.clearLocalStorage().then(this.clearLocalStorage().then(this.$router.push({name: 'login'})))
                })
        },
        handleRefreshToken() {
            return this.repositories.autenticacao.refresh()
                .then(({data}) => {
                    clearTimeout(this.notification)
                    clearTimeout(this.logout)

                    this.setExpiration(data.expiration)
                    this.setToken(data.token)
                    this.handleExpirationToken()
                })
                .catch(this.handleError)
        },
    },
    mixins: [error, notification],
    mounted() {
        this.handleExpirationToken()
    },
    props: {
        open: {type: Boolean},
    },
}
</script>

<style scoped>
.rkm-navbar {
    color: #ffffff !important;
}
.rkm-navbar-nav >>> .nav-link {
    color: #ffffff;
}
</style>